import React, { useState } from 'react';
import { ArrowLeftIcon, PlusIcon, CalendarIcon } from 'lucide-react';
import { DaySelector } from './DaySelector';
import { CreateOrderForm } from './CreateOrderForm';
import { OrderList } from './OrderList';
interface OrderPlanningProps {
  onBackToOverview?: () => void;
}
export function OrderPlanning({
  onBackToOverview
}: OrderPlanningProps) {
  const [view, setView] = useState<'list' | 'create'>('list');
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [orders, setOrders] = useState<Order[]>([{
    id: '1001',
    recipeId: '10632',
    recipeName: 'Gustoria Paella',
    quantity: 2.5,
    unit: 'Tonnen',
    date: new Date(),
    startTime: '08:00',
    endTime: '10:30',
    status: 'planned',
    line: 'Linie 1'
  }, {
    id: '1002',
    recipeId: '10633',
    recipeName: 'Gustoria Risotto',
    quantity: 1.8,
    unit: 'Tonnen',
    date: new Date(),
    startTime: '11:00',
    endTime: '12:30',
    status: 'planned',
    line: 'Linie 2'
  }]);
  const handleCreateOrder = () => {
    setView('create');
  };
  const handleBackToList = () => {
    setView('list');
  };
  const handleSaveOrder = (newOrder: Order) => {
    setOrders([...orders, {
      ...newOrder,
      id: `${1000 + orders.length + 1}`
    }]);
    setView('list');
  };
  const handleDateChange = (date: Date) => {
    setSelectedDate(date);
  };
  const handleReorderOrders = (reorderedOrders: Order[]) => {
    // Aktualisiere die Reihenfolge der Aufträge
    setOrders(prevOrders => {
      // Erstelle eine Kopie aller Aufträge
      const allOrders = [...prevOrders];
      // Finde die Aufträge für das ausgewählte Datum
      const selectedDateOrders = allOrders.filter(order => order.date.getDate() === selectedDate.getDate() && order.date.getMonth() === selectedDate.getMonth() && order.date.getFullYear() === selectedDate.getFullYear());
      // Ersetze die Aufträge für das ausgewählte Datum mit der neuen Reihenfolge
      const ordersMap = new Map(allOrders.map(order => [order.id, order]));
      // Aktualisiere die Aufträge in der Map mit den neu sortierten
      reorderedOrders.forEach(order => {
        ordersMap.set(order.id, order);
      });
      // Konvertiere die Map zurück in ein Array
      return Array.from(ordersMap.values());
    });
  };
  const filteredOrders = orders.filter(order => order.date.getDate() === selectedDate.getDate() && order.date.getMonth() === selectedDate.getMonth() && order.date.getFullYear() === selectedDate.getFullYear());
  return <div className="container mx-auto" data-id="element-1217">
      <div className="mb-8" data-id="element-1218">
        <div data-id="element-1219">
          <h2 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-1220">
            Auftragsplanung
          </h2>
          <p className="text-gray-600 mb-4" data-id="element-1221">
            Planung und Verwaltung von Produktionsaufträgen
          </p>
          {onBackToOverview}
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-md p-6" data-id="element-1222">
        <DaySelector selectedDate={selectedDate} onDateChange={handleDateChange} data-id="element-1223" />
        {view === 'list' ? <>
            <div className="flex justify-between items-center mb-6 mt-6" data-id="element-1224">
              <h3 className="text-xl font-bold text-gray-800" data-id="element-1225">
                Aufträge für{' '}
                {selectedDate.toLocaleDateString('de-DE', {
              weekday: 'long',
              day: '2-digit',
              month: '2-digit',
              year: 'numeric'
            })}
              </h3>
              <button onClick={handleCreateOrder} className="flex items-center gap-2 bg-[#8DC63F] hover:bg-[#7AB929] text-white px-4 py-2 rounded-lg transition-colors" data-id="element-1226">
                <PlusIcon size={18} data-id="element-1227" />
                <span data-id="element-1228">Neuer Auftrag</span>
              </button>
            </div>
            <OrderList orders={filteredOrders} onReorder={handleReorderOrders} data-id="element-1229" />
          </> : <>
            <button onClick={handleBackToList} className="flex items-center gap-2 mt-4 mb-4 text-gray-600 hover:text-gray-800" data-id="element-1230">
              <ArrowLeftIcon size={16} data-id="element-1231" />
              <span data-id="element-1232">Zurück zur Übersicht</span>
            </button>
            <CreateOrderForm onSave={handleSaveOrder} onCancel={handleBackToList} selectedDate={selectedDate} data-id="element-1233" />
          </>}
      </div>
    </div>;
}
export interface Order {
  id: string;
  recipeId: string;
  recipeName: string;
  quantity: number;
  unit: string;
  date: Date;
  startTime: string;
  endTime: string;
  status: 'planned' | 'in-progress' | 'completed' | 'cancelled';
  line: string;
}